var slice = window.slice;
var slice = [].slice;
$.fn.more_link = function () {
  var more_link_fn, params;
  more_link_fn = $.fn.more_link;
  params = arguments;
  return $(this).each(function (_, el) {
    return more_link_fn.init.apply(more_link_fn, [$(el)].concat(slice.call(params)));
  });
};
$.fn.more_link.init = function ($el, link_selector, hide_selector, show_selector) {
  var link, unique_data_key, unique_id;
  unique_id = GlobalIncrementor.next() + "-" + new Date().getTime();
  unique_data_key = "more-link-container-" + unique_id;
  $el.attr("data-" + unique_data_key, 'true');
  link = $el.find(link_selector);
  link.attr('data-more-link-behavior', 'true');
  link.attr('data-container', "*[data-" + unique_data_key + "=true]");
  link.attr('data-show', show_selector);
  return link.attr('data-hide', hide_selector);
};
window.slice = slice;